import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=1c9cb1f0"
import script from "./Noticia.vue?vue&type=script&setup=true&lang=js"
export * from "./Noticia.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports